import { createSlice } from "@reduxjs/toolkit";
import { extendSliceWithAssignees } from "slices/assignees/utils";

export const INITIAL_STATE = {
  isLoading: true,
  contract: null,
  documents: [],
  docTypes: [],
};

const detailSlice = createSlice({
  name: "detail",
  initialState: INITIAL_STATE,
  reducers: {
    setIsLoading: (state, { payload: isLoading = false }) => {
      state.isLoading = isLoading;
    },
    setContract(state, { payload = null }) {
      state.contract = payload;
    },
    ...extendSliceWithAssignees({
      rootPath: "contract",
      actionName: "setContractAssignees",
    }),
    setDocuments: (state, action) => {
      state.documents = action.payload;
    },
    removeDocument: (state, action) => {
      const id = action.payload;
      state.documents = state.documents.filter(
        (document) => document.id !== id
      );
    },
    setDocTypes: (state, action) => {
      state.docTypes = action.payload;
    },
    unsetContract() {
      return INITIAL_STATE;
    },
  },
});

export const {
  setIsLoading,
  setContract,
  setContractAssignees,
  setDocuments,
  removeDocument,
  setDocTypes,
  unsetContract,
} = detailSlice.actions;

export default detailSlice;
